
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

var $0d4d67917d9e06cf$exports = {};

(parcelRequire("1hiTA")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"gBTXw\",\"cards-extension.21f3e7aa.js\",\"iYZAq\",\"cards-extension.99add1f1.js\",\"2rpiM\",\"emoji-component.f0b79547.js\",\"28Uxk\",\"General.d0402e27.svg\",\"hxQfU\",\"NoDynamicCards.7cd8fd7d.svg\",\"4GPJP\",\"Warning.e56d4e3e.svg\",\"jgaRb\",\"video-pause.bf51a64e.js\",\"ffEVr\",\"vendors~editor_icon.eccba440.js\",\"boOz1\",\"cards-extension.5bf6e80e.js\",\"1he0z\",\"cards-extension.e657da6b.js\",\"5jMIH\",\"cards-extension.9af34130.js\",\"bB5i2\",\"no-results-dark.a00ae47b.svg\",\"8l5SF\",\"no-results-light.5ca83755.svg\",\"cgdGM\",\"error-dark.43e0a164.svg\",\"lrmTr\",\"error-light.02ef2e6f.svg\",\"jzKsa\",\"dynamic-cards-landing.82c00804.svg\",\"iz3Dh\",\"no-results-dark.a00ae47b.svg\",\"8eXlM\",\"no-results-light.5ca83755.svg\",\"aTi5X\",\"browser-storage-controls.c8075029.js\",\"6wr18\",\"vendors~editor_icon.d3a3610c.js\",\"auqwj\",\"cards-extension-icon.fa77c1b9.js\",\"497bd\",\"editor.c6fbb5c2.js\",\"aQPuI\",\"edition-benefits-modal-relay.b6c6c0ef.js\",\"iOA0g\",\"editor.150d914d.js\",\"9Yv0C\",\"carousel-extension-icon.ce266252.js\"]"));


$parcel$global.rlb("5NuZb")
//# sourceMappingURL=cards-extension.runtime.955c7267.js.map
